import { Popper, styled } from '@mui/material';

const InvisiblePopper = styled(Popper)`
  opacity: 0;
  box-shadow: none;
  border: none;
  width: 0;
  height: 0;
`;

export default InvisiblePopper;
